import { createRequestActionTypes, API_URL } from "../../../actions";
export const GET_USER_BALANCE_DATA_URL = `${API_URL}/profile/`;
export const UserBalanceDataActionTypes = {
  getUserBalanceData: createRequestActionTypes("GET_USER_BALANCE_DATA"),
};
